import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/workbench/WorkbenchClient.tsx");
